import { useEffect, useRef, useState } from 'react';

/**
 * Hook personalizado para detectar cuando un elemento entra en el viewport
 * @param {Object} options - Opciones para el IntersectionObserver
 * @returns {Array} [ref, isIntersecting] - Referencia al elemento y estado de intersección
 */
export const useIntersectionObserver = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [hasIntersected, setHasIntersected] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
        if (entry.isIntersecting && !hasIntersected) {
          setHasIntersected(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
        ...options
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [hasIntersected, options]);

  return [elementRef, isIntersecting, hasIntersected];
};

export default useIntersectionObserver;





















